import { createReducer, on } from "@ngrx/store";
import { InstructionActions, InstructionDetailsActions } from "../actions";
import { Instruction } from "src/app/models/instruction/instruction";
import { InstructionConfirmation } from "src/app/models/instruction/instruction-confirmation";
import { Chapter } from "src/app/models/instruction/chapter";
import { ChapterConfirmation } from "src/app/models/instruction/chapter-confirmation";
import { Question } from "src/app/models/question";

export interface InstructionDetailsState {
  myInstruction?: Instruction;
  isLoadingMyInstruction: boolean;
  myInstructionConfirmation?: InstructionConfirmation;
  isLoadingMyInstructionConfirmation: boolean;
  isConfirmingChapter: boolean;
  chapters: Chapter[];
  isLoadingChapters: boolean;
  chapterConfirmations: ChapterConfirmation[];
  isLoadingChapterConfirmations: boolean;
  questions: Question[];
  selectedChapter?: Chapter;
  isLoadingQuestions: boolean;
}

const initialState = {
  myInstruction: undefined,
  isLoadingMyInstruction: false,
  myInstructionConfirmation: undefined,
  isLoadingMyInstructionConfirmation: false,
  isConfirmingChapter: false,
  isLoadingChapters: false,
  chapters: [],
  chapterConfirmations: [],
  isLoadingChapterConfirmations: false,
  questions: [],
  isLoadingQuestions: false,
  selectedChapter: undefined,
} as InstructionDetailsState;

export const instructionDetailsReducer = createReducer(
  initialState,
  on(InstructionDetailsActions.loadMyInstruction, (state, _) => ({
    ...state,
    isLoadingMyInstruction: true,
    myInstruction: undefined,
    chapters: [],
    isLoadingChapters: false,
    chapterConfirmations: [],
    isLoadingChapterConfirmations: false,
  })),
  on(InstructionDetailsActions.loadedMyInstruction, (state, action) => ({
    ...state,
    isLoadingMyInstruction: false,
    myInstruction: action.instruction,
  })),
  on(
    InstructionDetailsActions.loadMyInstructionConfirmation,
    (state, action) => ({
      ...state,
      isLoadingMyInstructionConfirmation: true,
      myInstructionConfirmation: undefined,
    }),
  ),
  on(
    InstructionDetailsActions.loadedMyInstructionConfirmation,
    (state, action) => ({
      ...state,
      isLoadingMyInstructionConfirmation: false,
      myInstructionConfirmation: action.confirmation,
    }),
  ),
  on(InstructionDetailsActions.confirmChapter, (state) => ({
    ...state,
    isConfirmingChapter: true,
  })),
  on(InstructionDetailsActions.confirmedChapter, (state, action) => ({
    ...state,
    isConfirmingChapter: false,
  })),
  on(InstructionDetailsActions.confirmChapterFailed, (state, _) => ({
    ...state,
    isConfirmingChapter: false,
  })),
  on(InstructionDetailsActions.loadChapters, (state, _) => ({
    ...state,
    chapters: [],
    isLoadingChapters: true,
    selectedChapter: undefined,
  })),
  on(InstructionDetailsActions.loadedChapters, (state, action) => ({
    ...state,
    chapters: action.chapters,
    isLoadingChapters: false,
  })),
  on(InstructionDetailsActions.loadChapterConfirmations, (state, _) => ({
    ...state,
    chapterConfirmations: [],
    isLoadingChapterConfirmations: true,
  })),
  on(InstructionDetailsActions.loadedChapterConfirmations, (state, action) => ({
    ...state,
    chapterConfirmations: action.chapterConfirmations,
    isLoadingChapterConfirmations: false,
  })),
  on(InstructionDetailsActions.loadQuestionsForChapter, (state, _) => ({
    ...state,
    isLoadingQuestions: true,
    questions: [],
  })),
  on(InstructionDetailsActions.loadedQuestionsForChapter, (state, action) => ({
    ...state,
    isLoadingQuestions: false,
    questions: action.questions,
  })),
  on(InstructionDetailsActions.selectChapter, (state, action) => ({
    ...state,
    selectedChapter: action.chapter,
  })),
);
